import { OrganizationApplicationParameters } from '@platform/client/schemas';
import { FormsMultilineInput } from '@platform/components';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import { NeedHelpButton } from '../../components/NeedHelpButton';
import BackgroundImage from '../../images/Aanu-Gopald.png';

type FormValues = {
  solution: string;
};

export const OrgSolutionSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const [showExample, setShowExample] = useState(false);

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>();

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      solution: getApplicationDataByKey('solution') || '',
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      solution: data.solution,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      solution: watch('solution'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={props.isEditProfile}
    >
      <ApplicationPageContent
        title='Describe how your product or service addresses this problem?'
        description={
          'This helps professionals viewing your profile understand how your solution works. You can always update it later.'
        }
      >
        <FormsMultilineInput
          placeholder="Describe how you're addressing this problem"
          control={control}
          name='solution'
          rules={{
            maxLength: 500,
            required: 'Describe how your organization is solving the problem to continue.',
          }}
          formsError={errors.solution}
          characterCount={500}
        />
        <NeedHelpButton
          onClick={() => setShowExample(!showExample)}
          isOpen={showExample}
          helpContent={
            'We provide affordable solar-powered irrigation kits made for small farms. Farmers can pay in small amounts over time, and we offer training to help them use the system and grow more food.'
          }
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
